/**
 * Import depedencies
 */

import { combineReducers } from 'redux';
import localForage from 'localforage';
import { persistReducer } from 'redux-persist';

/**
 * Import reducers
 */

import { connectRouter } from 'connected-react-router';
import { reducer as notificationsReducer } from 'reapop';

import authenticationReducer from './authentication';
import treatmentReducer from './treatment';
import homeworkReducer from './homework';
import audioExerciseReducer from './audioExercise';
import flashExerciseReducer from './flashExercise';
import graphDataReducer from './graphData';
import exerciseReducer from './exercise';
import thermometerReducer from './thermometer';

/**
 * List all reducers
 */

const authenticationPersistConfig = {
    key: 'authentication',
    storage: localForage,
    whitelist: ['user', 'token'],
};

const treatmentPersistConfig = {
    key: 'treatment',
    storage: localForage,
    whitelist: ['entities'],
};

const homeworkPersistConfig = {
    key: 'homework',
    storage: localForage,
    whitelist: ['entities'],
};

const audioExercisePersistConfig = {
    key: 'audioExercise',
    storage: localForage,
    whitelist: ['entities'],
};

const flashExercisePersistConfig = {
    key: 'flashExercise',
    storage: localForage,
    whitelist: ['entities'],
};

const graphDataPersistConfig = {
    key: 'graphData',
    storage: localForage,
    whitelist: ['entities'],
};

const exercisePersistConfig = {
    key: 'exercise',
    storage: localForage,
    whitelist: ['entities'],
};

const thermometerPersistConfig = {
    key: 'thermometer',
    storage: localForage,
    whitelist: ['entities'],
};

export default (history) =>
    combineReducers({
        router: connectRouter(history),
        notifications: notificationsReducer(),
        authentication: persistReducer(
            authenticationPersistConfig,
            authenticationReducer
        ),
        treatment: persistReducer(treatmentPersistConfig, treatmentReducer),
        homework: persistReducer(homeworkPersistConfig, homeworkReducer),
        audioExercise: persistReducer(
            audioExercisePersistConfig,
            audioExerciseReducer
        ),
        flashExercise: persistReducer(
            flashExercisePersistConfig,
            flashExerciseReducer
        ),
        graphData: persistReducer(graphDataPersistConfig, graphDataReducer),
        exercise: persistReducer(exercisePersistConfig, exerciseReducer),
        thermometer: persistReducer(
            thermometerPersistConfig,
            thermometerReducer
        ),
    });
